jQuery(function ($) {
  $(window).on("load scroll", function () {
    if (window.scrollY >= 500) {
      $(".fixed-reserve-link").fadeIn();
    } else {
      $(".fixed-reserve-link").fadeOut();
    }
  });
});
